export enum BLOCK_CATEGORIES {
  RECENTLY = 'Recently added',
  ESSENTIALS = 'Essentials',
  MEDIA = 'Media embed',
  ADVANCED = 'Advanced',
}
